import { Pipe, PipeTransform } from '@angular/core';

/**
 * String truncate pipe. Adds three dots to the end of truncated string
 */
@Pipe({
  name: 'qmTruncate'
})
export class TruncatePipe implements PipeTransform {

  /**
   * @param {string} value - target string
   * @param limit
   * @param trail
   * @returns {string}
   */
  transform(value: string, limit = 10, trail = '...'): string {
    if (!value) {
      return '';
    }
    return value.length > limit ? value.substring(0, limit) + trail : value;
  }

}
